export const BancoRecaudador = [
  {
    name: 'Todos',
    value: 0
  },
  {
    name: 'Banco de chile',
    value: 1
  },
  {
    name: 'Scotiabank',
    value: 2
  },
  {
    name: 'BCI',
    value: 3
  },
  {
    name: 'Banco estado',
    value: 4
  },
]